import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import { useHistory } from "react-router-dom";
import './index.css';
import api from '../../services/api_despesas';
import { format } from 'date-fns-tz';
import moment from 'moment';
import styles from "./styles.module.css";

export default function Reforma() {

    const [cenarios, setCenarios] = useState([]);
    const [safras, setSafras] = useState([]);
    const [safra, setSafra] = useState('');
    const [isControladoria, setIsControladoria] = useState(false);
    const [viewSafras, setViewSafras] = useState(false);
    const [canAprove, setCanAprove] = useState(false);

    let history = useHistory();

    useEffect(() => {
        api.get(`/usuario/getPerfilByUser`).then(function (response) {
            if (response.data) {
                if (response.data.usuario_perfil) {
                    response.data.usuario_perfil.forEach((perf, index) => {
                        if (parseInt(perf.perfil_id) === 5) {
                            setIsControladoria(true);
                        }

                        if (parseInt(perf.perfil_id) === 1 || parseInt(perf.perfil_id) === 5 || parseInt(perf.perfil_id) === 6) {
                            setCanAprove(true);
                        }

                    })

                }
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

    }, []);

    useEffect(() => {
        api.get(`/cenario/safras`).then(function (response) {
            if (response.data) {
                setSafras(response.data);
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

    }, []);

    useEffect(() => {
        if (safra !== '') {
            api.get(`/cenario/getall?safra=${safra}`).then(function (response) {
                if (response.data) {
                    setCenarios(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });
        }
    }, [safra]);

    function clickCenario(cenario) {
        history.push(`/refespec/cenario/${cenario}`);
    }

    function renderCenarios() {

        return (
            cenarios.map((cenario) => {
                if (cenario.status === 0) {
                    return (
                        <input id={cenario.id} type="button" className={styles.cenarioclosed} value={cenario.descricao} onClick={() => clickCenario(cenario.id)} />
                    )
                } else {
                    return (
                        <input id={cenario.id} type="button" className={styles.cenarioopen} value={cenario.descricao} onClick={() => clickCenario(cenario.id)} />
                    )

                }

            })
        )

    }

    function clickSafra(ano) {
        setSafra(ano);
    }

    function renderBtnBorder(safra) {
        if (parseInt(safra) === parseInt(moment(new Date()).utc().format('YYYY'))) {
            return (styles.anoatual)
        } else if (parseInt(safra) < parseInt(moment(new Date()).utc().format('YYYY'))) {
            return (styles.anoanterior)
        } else {
            return (styles.anoproximo)
        }
    }

    function renderSafras() {
        return (
            safras.map((ano) => {
                return (
                    <input key={ano} type="button" value={ano.safra}
                        className={renderBtnBorder(ano.safra)}
                        onClick={() => clickSafra(ano.safra)}
                    />
                )
            })
        )
    }

    function handleManutCenario() {
        history.push('/manutcenario')
    }

    function handleClickParametros() {
        history.push('/parametrosreforma')
    }

    function renderManutCenario() {
        if (isControladoria) {
            return (
                <input type="button" className='btn btn-primary card-orcamento' value="MANUTENÇÃO DE CENÁRIOS" onClick={() => handleManutCenario()} />
            )
        }
    }

    function renderViewSafras() {
        if (viewSafras) {
            return (
                <>
                    <div>
                        {renderSafras()}
                    </div>
                    <div className={styles.divcenarios}>
                        {renderCenarios()}
                    </div>
                </>
            )
        }
    }

    function handleClickAprovacoes() {
        history.push('/aprovacoesreforma');
    }

    function renderBtnAprovacao() {
        if (canAprove) {
            return (
                <div className={styles.btnoperreforma}>
                    <input type="button" className='btn tbn-sm btn-success' value="APROVAÇÕES" onClick={() => handleClickAprovacoes()} />
                </div>
            )
        } else {
            return (<></>)
        }
    }

    function handleClickRelatorios() {
        history.push('/relatoriosreforma');
    }

    return (
        <div className="container-lg">
            <Header title="PLANEJAMENTO DE REFORMA" />
            <div>
                <input type="button" className="btn-primary btn btn-reforma" VALUE="ROTEIRO DA REFORMA" onClick={() => handleClickParametros()} />
                {renderManutCenario()}
            </div>
            <hr />
            <div className={styles.btnsoperreforma}>
                <div className={styles.btnoperreforma}>
                    <input type="button" className='btn tbn-sm btn-primary' value="PREVISÃO ORÇAMENTARIA" onClick={() => setViewSafras(true)} />
                </div>
                {renderBtnAprovacao()}
                <div className={styles.btnoperreforma}>
                    <input type="button" className='btn tbn-sm btn-warning' value="RELATÓRIOS" onClick={() => handleClickRelatorios()} />
                </div>
            </div>
            {renderViewSafras()}
            <div className={styles.divlegenda}>
                <b>LEGENDA:</b>
                <hr />
                <div className={styles.safracen}>
                    <div>
                        <b>SAFRA</b>
                        <div className={styles.legendasafra}>
                            <div className={styles.anoanterior}><b>SAFRA ANTERIOR</b></div>
                            <div className={styles.anoatual}><b>SAFRA ATUAL</b></div>
                            <div className={styles.anoproximo}><b>SAFRA FUTURA</b></div>
                        </div>
                    </div>
                    <div>
                        <b>CENÁRIO</b>
                        <div className={styles.legendacenario}>
                            <div className={styles.cenarioclosed}><b>CENÁRIO FECHADO</b></div>
                            <div className={styles.cenarioopen}><b>CENÁRIO ABERTO</b></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}